<template>
  <div class="overflow-y-scroll">
    <h3>Company</h3>
    <section class="map-info">
      <div class="form-inline">
        <label>name:</label>
        <div>{{name ? name : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label>Main Contact:</label>
        <div>{{email ? email : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label>Billing Contact:</label>
        <div>{{billingEmail ? billingEmail : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label>General Rate:</label>
        <div>{{rate ? rate : 0 | currencyFilter('$', 2)}}</div>
      </div>
      <div class="form-inline">
        <label>Active:</label>
        <div>{{isActive ? isActive : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label>Stripe ID:</label>
        <div>{{stripeId ? stripeId : 'none'}}</div>
      </div>
      <div class="form-inline">
        <label for="about">About:</label>
        <div>{{about ? about : 'none'}}</div>
      </div>
      <div class="form-inline">
        <button class="submit primary" @click="toClientDashboard">Client Dashboard</button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: [
    "name",
    "email",
    "billingEmail",
    "rate",
    "isActive",
    "stripeId",
    "about",
    "id"
  ],
  methods: {
    toClientDashboard: function() {
      this.$router.push({
        path: "/home/Client/client_dashboard",
        query: { id: this.id }
      });
    }
  }
};
</script>